var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageWrapDefault',{attrs:{"errorMessage":_vm.errorMessage,"successMessage":_vm.successMessage,"topActionButtonPrimary":_vm.$getCurrentUser && _vm.$getCurrentUser.role === 'admin'
      ? {
          text: 'Create New Agency',
          key: 'create'
        }
      : {}},on:{"toolbarSelectItem":_vm.onToolbarItemClick,"errorMessageClosed":function($event){_vm.errorMessage = ''}}},[_c('ListAgenciesTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }